export default {
  "b2b.zadosti-odbaveni-grid.action-filter": "Filter",
  "b2b.zadosti-odbaveni-grid.dialogAccept.title": "Confirmation of request",
  "b2b.zadosti-odbaveni-grid.dialogDecline.title": "Denial of request",
  "b2b.zadosti-odbaveni-grid.filter.dateFrom.label": "Date from",
  "b2b.zadosti-odbaveni-grid.filter.dateTo.label": "Date to",
  "b2b.zadosti-odbaveni-grid.filter.zdroj.label": "Resource of request",
  "b2b.zadosti-odbaveni-grid.label": "Request processing",
  "b2b.zadosti-odbaveni-grid.toolbarItemAccept.label": "CONFIRM",
  "b2b.zadosti-odbaveni-grid.toolbarItemDecline.label": "DENY"
};
